import * as React from "react";
import { SVGProps } from "react";

const ChevronUpSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.43 18.875a1.47 1.47 0 0 0 .107-2.074L13.09 5.23a1.47 1.47 0 0 0-2.18 0L.463 16.8a1.47 1.47 0 0 0 .107 2.074 1.47 1.47 0 0 0 2.075-.106L12 8.406l9.355 10.363a1.47 1.47 0 0 0 2.075.106z"
    />
  </svg>
);

export default ChevronUpSVG;
